export enum CharterInvoiceTypeEnum {
  New = 1,
  Additional = 2,
  Split = 3,
  Modified = 4,
}
